module.exports = __webpack_public_path__ + "img/tedexis-light-small.1b4b63dc.svg";